import { getValue, skippable } from 'indicative-utils'
import libphonenumber from 'google-libphonenumber'
const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

export default (extend) => {
  extend('e164', {
    async: true,
    async validate(data, field, args, config) {
      try {
        const fieldValue = getValue(data, field)
        if (skippable(fieldValue, field, config)) return true
        return phoneUtil.isValidNumber(phoneUtil.parse(fieldValue))
      } catch (error) {
        return false;
      }
    }
  })
}